function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Material imports
import MuiBadge from "@mui/material/Badge";
const Badge = ({
  name,
  content,
  count = 0,
  variant = "dot",
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(MuiBadge, _extends({
    id: `${name}Badge`,
    variant: variant,
    invisible: count < 1
  }, rest), content);
};
export default Badge;
Badge.propTypes = {
  name: PropTypes.string,
  count: PropTypes.number,
  content: PropTypes.node.isRequired,
  variant: PropTypes.string
};